function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _class, _updateFilesAndInputMode, _temp;

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

var _require = require('preact'),
    h = _require.h;

var SearchInput = require('./InputView');

var Browser = require('../Browser');

var LoaderView = require('../Loader');

var Header = require('./Header');

var CloseWrapper = require('../CloseWrapper');

var View = require('../View');
/**
 * Class to easily generate generic views for Provider plugins
 */


module.exports = (_temp = (_updateFilesAndInputMode = /*#__PURE__*/_classPrivateFieldLooseKey("updateFilesAndInputMode"), _class = /*#__PURE__*/function (_View) {
  _inherits(SearchProviderView, _View);

  var _super = _createSuper(SearchProviderView);

  /**
   * @param {object} plugin instance of the plugin
   * @param {object} opts
   */
  function SearchProviderView(plugin, opts) {
    var _this2;

    _classCallCheck(this, SearchProviderView);

    _this2 = _super.call(this, plugin, opts); // set default options

    Object.defineProperty(_assertThisInitialized(_this2), _updateFilesAndInputMode, {
      value: _updateFilesAndInputMode2
    });
    var defaultOptions = {
      viewType: 'grid',
      showTitles: false,
      showFilter: false,
      showBreadcrumbs: false
    }; // merge default options with the ones set by user

    _this2.opts = _objectSpread(_objectSpread({}, defaultOptions), opts); // Logic

    _this2.search = _this2.search.bind(_assertThisInitialized(_this2));
    _this2.triggerSearchInput = _this2.triggerSearchInput.bind(_assertThisInitialized(_this2));
    _this2.addFile = _this2.addFile.bind(_assertThisInitialized(_this2));
    _this2.handleScroll = _this2.handleScroll.bind(_assertThisInitialized(_this2));
    _this2.donePicking = _this2.donePicking.bind(_assertThisInitialized(_this2)); // Visual

    _this2.render = _this2.render.bind(_assertThisInitialized(_this2)); // Set default state for the plugin

    _this2.plugin.setPluginState({
      isInputMode: true,
      files: [],
      folders: [],
      directories: [],
      filterInput: '',
      currentSelection: [],
      searchTerm: null
    });

    return _this2;
  }

  _createClass(SearchProviderView, [{
    key: "tearDown",
    value: function tearDown() {// Nothing.
    }
  }, {
    key: "clearSelection",
    value: function clearSelection() {
      this.plugin.setPluginState({
        currentSelection: [],
        isInputMode: true,
        files: [],
        searchTerm: null
      });
    }
  }, {
    key: "search",
    value: function search(query) {
      var _this3 = this;

      var _this$plugin$getPlugi = this.plugin.getPluginState(),
          searchTerm = _this$plugin$getPlugi.searchTerm;

      if (query && query === searchTerm) {
        // no need to search again as this is the same as the previous search
        return;
      }

      return this.sharedHandler.loaderWrapper(this.provider.search(query), function (res) {
        _classPrivateFieldLooseBase(_this3, _updateFilesAndInputMode)[_updateFilesAndInputMode](res, []);
      }, this.handleError);
    }
  }, {
    key: "triggerSearchInput",
    value: function triggerSearchInput() {
      this.plugin.setPluginState({
        isInputMode: true
      });
    }
  }, {
    key: "handleScroll",
    value: function () {
      var _handleScroll = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
        var query, _this$plugin$getPlugi2, files, searchTerm, response;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                query = this.nextPageQuery || null;

                if (!(this.shouldHandleScroll(event) && query)) {
                  _context.next = 17;
                  break;
                }

                this.isHandlingScroll = true;
                _context.prev = 3;
                _this$plugin$getPlugi2 = this.plugin.getPluginState(), files = _this$plugin$getPlugi2.files, searchTerm = _this$plugin$getPlugi2.searchTerm;
                _context.next = 7;
                return this.provider.search(searchTerm, query);

              case 7:
                response = _context.sent;

                _classPrivateFieldLooseBase(this, _updateFilesAndInputMode)[_updateFilesAndInputMode](response, files);

                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](3);
                this.handleError(_context.t0);

              case 14:
                _context.prev = 14;
                this.isHandlingScroll = false;
                return _context.finish(14);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 11, 14, 17]]);
      }));

      function handleScroll(_x) {
        return _handleScroll.apply(this, arguments);
      }

      return handleScroll;
    }()
  }, {
    key: "donePicking",
    value: function donePicking() {
      var _this4 = this;

      var _this$plugin$getPlugi3 = this.plugin.getPluginState(),
          currentSelection = _this$plugin$getPlugi3.currentSelection;

      var promises = currentSelection.map(function (file) {
        return _this4.addFile(file);
      });
      this.sharedHandler.loaderWrapper(Promise.all(promises), function () {
        _this4.clearSelection();
      }, function () {});
    }
  }, {
    key: "render",
    value: function render(state, viewOptions) {
      var _this = this;

      if (viewOptions === void 0) {
        viewOptions = {};
      }

      var _this$plugin$getPlugi4 = this.plugin.getPluginState(),
          didFirstRender = _this$plugin$getPlugi4.didFirstRender,
          isInputMode = _this$plugin$getPlugi4.isInputMode,
          searchTerm = _this$plugin$getPlugi4.searchTerm;

      if (!didFirstRender) {
        this.preFirstRender();
      }

      var targetViewOptions = _objectSpread(_objectSpread({}, this.opts), viewOptions);

      var _this$plugin$getPlugi5 = this.plugin.getPluginState(),
          files = _this$plugin$getPlugi5.files,
          folders = _this$plugin$getPlugi5.folders,
          filterInput = _this$plugin$getPlugi5.filterInput,
          loading = _this$plugin$getPlugi5.loading,
          currentSelection = _this$plugin$getPlugi5.currentSelection;

      var _this$sharedHandler = this.sharedHandler,
          isChecked = _this$sharedHandler.isChecked,
          toggleCheckbox = _this$sharedHandler.toggleCheckbox,
          filterItems = _this$sharedHandler.filterItems;
      var hasInput = filterInput !== '';
      var browserProps = {
        isChecked: isChecked,
        toggleCheckbox: toggleCheckbox,
        currentSelection: currentSelection,
        files: hasInput ? filterItems(files) : files,
        folders: hasInput ? filterItems(folders) : folders,
        handleScroll: this.handleScroll,
        done: this.donePicking,
        cancel: this.cancelPicking,
        headerComponent: Header({
          search: this.search,
          i18n: this.plugin.uppy.i18n,
          searchTerm: searchTerm
        }),
        title: this.plugin.title,
        viewType: targetViewOptions.viewType,
        showTitles: targetViewOptions.showTitles,
        showFilter: targetViewOptions.showFilter,
        showBreadcrumbs: targetViewOptions.showBreadcrumbs,
        pluginIcon: this.plugin.icon,
        i18n: this.plugin.uppy.i18n,
        uppyFiles: this.plugin.uppy.getFiles(),
        validateRestrictions: function validateRestrictions() {
          var _this$plugin$uppy;

          return (_this$plugin$uppy = _this.plugin.uppy).validateRestrictions.apply(_this$plugin$uppy, arguments);
        }
      };

      if (loading) {
        return h(CloseWrapper, {
          onUnmount: this.clearSelection
        }, h(LoaderView, {
          i18n: this.plugin.uppy.i18n
        }));
      }

      if (isInputMode) {
        return h(CloseWrapper, {
          onUnmount: this.clearSelection
        }, h(SearchInput, {
          search: this.search,
          i18n: this.plugin.uppy.i18n
        }));
      }

      return h(CloseWrapper, {
        onUnmount: this.clearSelection
      }, h(Browser, browserProps));
    }
  }]);

  return SearchProviderView;
}(View)), _class.VERSION = "2.0.8", _temp);

function _updateFilesAndInputMode2(res, files) {
  this.nextPageQuery = res.nextPageQuery;
  res.items.forEach(function (item) {
    files.push(item);
  });
  this.plugin.setPluginState({
    isInputMode: false,
    files: files,
    searchTerm: res.searchedFor
  });
}